import e from "./index911.js";
var t = e(Object.keys, Object);
export {
  t as default
};
